const SHIPPED = {
  cod: 'SHIPPED',
  title: 'Produto Em Transporte'
}
const IN_TRANSPORT = {
  cod: 'IN_TRANSPORT',
  title: 'Em Transferência'
}
const IN_PROGRESS_AFTER_BILLED = {
  cod: 'IN_PROGRESS_AFTER_BILLED',
  title: 'Agendado'
}
const TRACKED = {
  cod: 'TRACKED',
  title: 'Em Rota'
}
const INSUCESS = {
  cod: 'INSUCESS',
  title: 'Alguma coisa deu errado…'
}
const STOCKOUT = {
  cod: 'STOCKOUT',
  title: 'Avaria'
}
const RETURN = {
  cod: 'RETURN',
  title: 'Em Devolução'
}
const DELIVERED = {
  cod: 'DELIVERED',
  title: 'Entrega Realizada'
}
const MATERIAL_LOST = {
  cod: 'MATERIAL_LOST',
  title: 'Extravio'
}

export {
  SHIPPED,
  IN_TRANSPORT,
  IN_PROGRESS_AFTER_BILLED,
  TRACKED,
  INSUCESS,
  STOCKOUT,
  RETURN,
  DELIVERED,
  MATERIAL_LOST
}
